<template>
    <section>
      <div v-if="getRole !== 'Analytics'" class="container.is-widescreen" style="padding-top:18px">

            <h1 class="title" style="color:#3e8ed0">Send bulk SMS</h1>
            <h4 class="subtitle">Send a message to many users.</h4>

                    <div class="container">
                      <div style="text-align: center;padding-bottom: 20px">

<p @click="isImageModalActive = true" style="cursor: pointer;color:#3e8ed0">Click to see required file format</p>
</div>
<b-modal :width="300" v-model="isImageModalActive" >
            <p class="image" >
                <img src="../../assets/fileformat.png" >
            </p>
        </b-modal>
                        <div class="row" style="padding-bottom: 20px;">
    <div class="col">
        <b-field label="Project:">
          <b-select v-model="projectId" expanded>
              <option v-for="(value, key) in allProjects" :key="key" :value="value._id">
                {{ value.name }}
              </option>
            </b-select>
             <p v-if="selectedProject && selectedProject.allowCyrillic === false" style="color: #d9534f; font-size: 12px;">
                Cyrillic/Unicode/non-GSM messages are not allowed for this project.
            </p>
        </b-field>
    </div>
    <div class="col">
        <b-field label="Receivers:">
            <!--<input
        type="file"
        v-on:change="addfile($event)"
        placeholder="Upload file"
        accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />-->

      <b-field class="file is-primary" :class="{'has-name': !!file}">
        <b-upload v-model="file" class="file-label" accept=".xlsx, .csv, .ods" required validationMessage="Please select a file">
            <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Click to upload (.xlxs, .csv or .ods)</span>
            </span>
            <span class="file-name" v-if="file">
                {{ file.name }}
            </span>
        </b-upload>
    </b-field>

        </b-field>
    </div>
  </div>

  <div style="text-align: center;">

        <b-field label="Message text:">
            
      <b-input v-model="messageText" type="textarea" 
        :maxlength="maxLength"
        :has-counter="false">
        </b-input>
        </b-field>

        <div style="text-align: right; font-size: 12px; color: #666; margin-top: -10px;">
          {{ count || 0 }} / {{ maxLength }}
        </div>

</div>

<div style="text-align: center; padding-bottom: 10px; color: red">
<p><b>{{ countString }} {{ noMessagesString }}</b></p>
</div>
  
  <div style="text-align: center;">
  <b-button type="is-primary" @click="addMess">Submit</b-button>
</div>
</div>
</div>
    </section>
  </template>
  
<script>
import { mapActions, mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import {
  analyzeSmsText,
  containsCyrillic as textContainsCyrillic,
  getTextareaMaxLength,
  trimTextToA1Limit
} from '@/utils/smsCounter'

export default {
  name: 'SendMessages',
  computed: {
    ...mapGetters(['allProjects', 'getRole', 'getWorkspaceId', 'getSessionId']),
    selectedProject () {
      return this.allProjects.find(project => project._id === this.projectId) || null
    }
  },
  created: function () {
    if (this.getRole === 'Super Admin') {
      this.fetchSendProjects()
    } else if (this.getRole !== 'Analytics') {
      this.fetchSendProjectsByWorkspaceId(this.getWorkspaceId)
    }
  },
  mounted: function () {
    this.updateSession(this.getSessionId)
  },
  data () {
    return {
      messageText: '',
      receiver: null,
      projectId: null,
      file: null,
      arrayBuffer: null,
      filelist: null,
      count: null,
      noMessages: 0,
      noMessagesString: null,
      countString: null,
      maxLength: 612,
      isImageModalActive: false
    }
  },
watch: {
  file () {
    this.addfile()
  },
  messageText (newValue, oldValue) {
    this.updateMessageCounter(oldValue || '')
  }
},
  methods: {
    ...mapActions(['fetchSendProjects', 'addMessage', 'fetchSendProjectsByWorkspaceId', 'addSingleMessage', 'updateSession']),

    containsCyrillic (text) {
      return textContainsCyrillic(text)
    },

    updateMessageCounter (previousText = '') {
  if (!this.messageText) {
    this.count = null
    this.noMessages = 0
    this.countString = null
    this.noMessagesString = null
    this.maxLength = 612
    return
  }

  const trimmedText = trimTextToA1Limit(this.messageText, previousText)
  if (trimmedText !== this.messageText) {
    this.messageText = trimmedText
    return
  }

  const analysis = analyzeSmsText(this.messageText)

  this.count = analysis.unitCount
  this.noMessages = analysis.parts
  this.maxLength = getTextareaMaxLength(this.messageText)
  this.countString = this.count === 1
    ? '1 character,'
    : this.count + ' characters,'
  this.noMessagesString = this.noMessages === 1
    ? '1 message'
    : this.noMessages + ' messages'
},

    showCyrillicAlert () {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: 'Cyrillic/Unicode/non-GSM characters are not allowed for this project',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      })
    },

    async addMess () {
      if (this.projectId === null || this.messageText === '' || this.file === null) {
        this.$buefy.dialog.alert({
          title: 'Error',
          message: 'Please fill in all fields.',
          confirmText: 'Ok!',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa'
        })
      } else if (this.selectedProject && this.selectedProject.allowCyrillic === false && this.containsCyrillic(this.messageText)) {
        this.showCyrillicAlert()
      } else {
        if (this.filelist.length > 100) {
          const size = 100
          const subArrays = []
          for (let i = 0; i < this.filelist.length; i += size) {
            subArrays.push(this.filelist.slice(i, i + size))
          }
          const payload = {
            text: this.messageText,
            projectId: this.projectId,
            size: this.noMessages,
            noOfCalls: subArrays.length
          }
          for (let j = 0; j < subArrays.length; j++) {
            payload.receiver = subArrays[j]
            payload.currentCall = j + 1
            await this.addMessage(payload)
          }
          this.reset()
        } else {
          const payload = {
            text: this.messageText,
            receiver: this.filelist,
            projectId: this.projectId,
            size: this.noMessages
          }
          await this.addSingleMessage(payload)
          this.reset()
        }
        this.updateSession(this.getSessionId)
      }
    },

    reset () {
      this.messageText = ''
      this.receiver = null
      this.projectId = null
      this.count = null
      this.noMessages = 0
      this.countString = null
      this.noMessagesString = null
      this.maxLength = 612
    },

    addfile () {
      const fileReader = new FileReader()
      if (this.file) {
        fileReader.readAsArrayBuffer(this.file)
      }
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result
        const data = new Uint8Array(this.arrayBuffer)
        const arr = []
        for (let i = 0; i !== data.length; ++i) {
          arr[i] = String.fromCharCode(data[i])
        }
        const bstr = arr.join('')
        const workbook = XLSX.read(bstr, { type: 'binary' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        this.globalLogger(XLSX.utils.sheet_to_json(worksheet, { raw: true }))
        const arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true })
        this.globalLogger(arraylist, 'araylist')
        this.filelist = []
        for (let i = 0; i < arraylist.length; i++) {
          if (arraylist[i].Number !== undefined) {
            this.filelist.push(arraylist[i].Number.toString())
          } else {
            this.file = null
            this.showAlert()
            break
          }
        }
        this.globalLogger(this.filelist, 'file list')
      }
    },

    showAlert () {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: 'Incorrect file format. Please see required file format.',
        confirmText: 'Ok!',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa'
      })
    }
  }
}
</script>

<style>
</style>